import { render, staticRenderFns } from "./Habilitacion.vue?vue&type=template&id=d379f3e4&"
import script from "./Habilitacion.vue?vue&type=script&lang=js&"
export * from "./Habilitacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports